import { ButtonGroup } from "react-bootstrap";
import ToggleButton from "react-bootstrap/ToggleButton";
import { IconType } from "react-icons/lib";

interface CustomToggleButtonProps {
  onChange: () => void;
  variant?:
    | "primary"
    | "secondary"
    | "success"
    | "danger"
    | "warning"
    | "info"
    | "dark"
    | "light"
    | "link"
    | "outline-primary"
    | "outline-secondary"
    | "outline-success"
    | "outline-danger"
    | "outline-warning"
    | "outline-info"
    | "outline-dark"
    | "outline-light";
  checked: boolean;
  label: string;
  leftIcon?: IconType | undefined;
  rightIcon?: IconType | undefined;
  size?: "lg" | "sm";
  value: any;
}

const CustomToggleButton: React.FC<CustomToggleButtonProps> = (props) => {
  return (
    <ButtonGroup>
      <ToggleButton
        size={props.size ? props.size : "sm"}
        id="toggle-check"
        type="checkbox"
        variant={props.variant ? props.variant : "outline-primary"}
        checked={props.checked}
        color="#2f4050"
        value={props.value}
        onChange={props.onChange}
      >
        <span className="icon-container">
          {props.leftIcon && <props.leftIcon className={"icon-left"} />}
          {props.label}
          {props.rightIcon && <props.rightIcon className={"icon-right"} />}
        </span>
      </ToggleButton>
    </ButtonGroup>
  );
};

export default CustomToggleButton;
